import { render } from "./GarantyBanner.vue?vue&type=template&id=010b05d2"
import script from "./GarantyBanner.vue?vue&type=script&lang=js"
export * from "./GarantyBanner.vue?vue&type=script&lang=js"

import "./GarantyBanner.vue?vue&type=style&index=0&id=010b05d2&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__